
export const AiRelabalanceTotalCard = ({
    label = "",
    value = "",
}) => {
    return (
        <div className="rounded-md border border-border bg-background/70 px-3 py-2">
            <p className="text-[10px] uppercase tracking-[0.14em] text-gray-600">{label}</p>
            <p className="mt-1 text-sm font-semibold text-primary">{value}</p>
        </div>
    )
}